import { withStateHandlers } from 'recompose'

const chosen = ({ initialValue = 0 } = {}) =>
  withStateHandlers(
    { chosenIndex: initialValue },
    {
      chosenHandler: () => index => ({
        chosenIndex: index
      })
    }
  )

export default chosen
